import CloseIcon from '@mui/icons-material/Close';
import { Button,Dialog,DialogActions,DialogContent,DialogTitle,IconButton,TextField } from '@mui/material';
import { useContext,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../../context/UserContext';
import { trackEventMatomo } from '../../../helpers/matomo';

export default function NewModal({
  setModalOpen,
  modalOpen,
  create,
  nameCreate,
  isDisabled
}
  : {
    setModalOpen: Function,
    modalOpen: boolean,
    create: Function,
    nameCreate: string
    isDisabled: boolean
  }) {
  const { t } = useTranslation('translation');
  const { hierarchyLabel } = useContext(UserContext);
  const [name, setName] = useState('');

  const submit = () => {
    trackEventMatomo('Modal criação de conjunto/unidade', 'click', 'button', 'salvar');
    create(name);
  };


  return (
    <Dialog
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      scroll={'paper'}
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle>{
        `${t('Services.ServiceModal.add')} ${nameCreate === 'conjunto'
          ? hierarchyLabel.conjunto ?? 'Conjunto'
          : hierarchyLabel.unidade ?? 'Unidade'}`}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setModalOpen(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers={true}>
        <TextField
          onClick={() => trackEventMatomo('Modal criação de conjunto/unidade', 'click', 'textfield', 'editar valor')}
          style={{ marginBottom: '20px' }}
          fullWidth
          label={t('name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={name === '' || isDisabled} onClick={() => submit()}>
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
